/**
 * What `@react-email/render` adds to everything it renders, and how to take it
 * off again.
 *
 * `render()` prepends the doctype whatever the tree is — there is no option for
 * it — and React's own `<Suspense>` wraps the output in a comment pair. Both
 * sides of the app render with it: the composer serializes what was typed, and
 * anything the send path appends to that has to arrive in the same shape.
 *
 * These are fixed strings we emit ourselves, so this is a slice. A regex here
 * would only be usually-right, and a parser would be answering a question
 * nobody asked.
 */

const RENDER_DOCTYPE =
  '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">';
const SUSPENSE_OPEN = '<!--$-->';
const SUSPENSE_CLOSE = '<!--/$-->';

export function stripRenderWrapper(html: string) {
  let fragment = html.startsWith(RENDER_DOCTYPE)
    ? html.slice(RENDER_DOCTYPE.length)
    : html;

  if (fragment.startsWith(SUSPENSE_OPEN)) {
    fragment = fragment.slice(SUSPENSE_OPEN.length);
  }

  if (fragment.endsWith(SUSPENSE_CLOSE)) {
    fragment = fragment.slice(0, -SUSPENSE_CLOSE.length);
  }

  return fragment;
}
